import { render, staticRenderFns } from "./NewSupplier.vue?vue&type=template&id=dd02f592&scoped=true&lang=pug&"
import script from "./NewSupplier.vue?vue&type=script&lang=ts&"
export * from "./NewSupplier.vue?vue&type=script&lang=ts&"
import style0 from "./NewSupplier.vue?vue&type=style&index=0&id=dd02f592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd02f592",
  null
  
)

export default component.exports